import { Box } from "@mui/material";
import { TabPanel } from "@mui/lab";
import { styled } from "@mui/material/styles";

export const StyledWrapper = styled(Box)(({ theme }) => ({
  width: "100%",
  height: "100%",
  backgroundColor: "#fafaff",
  margin: "0",
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",

  [theme.breakpoints.down("sm")]: {
    height: "auto",
    overflow: "auto",
  },
}));

export const StyledTabPanel = styled(TabPanel)(({ theme }) => ({
  padding: 0,
  height: "calc(100% - 56px)",
  minHeight: 0,
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",

  "&[hidden]": {
    display: "none",
  },

  [theme.breakpoints.down("sm")]: {
    height: "auto",
    overflow: "visible",
  },
}));
